import API from "./APIService"
import BaseService from "./BaseService"

class CountriesService extends BaseService {
	component = null

	constructor(component = null) {
		super()
		this.component = component
	}

	baseServicePath = () => {
		return API.url("countries")
	}
}

export default CountriesService
